import { useLocalSearchParams, useRouter } from 'expo-router';
import { useState } from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { CarRatingsView } from '@/components/dashboard/car-ratings-view';
import { parseDashboardMonthCount } from '@/components/dashboard/dashboard-route-params';

export default function DashboardCarRatingsScreen() {
  const { styles, theme } = useStyles(stylesheet);
  const router = useRouter();
  const params = useLocalSearchParams<{ months?: string }>();
  const [monthCount, setMonthCount] = useState(() =>
    parseDashboardMonthCount(params.months)
  );

  return (
    <View
      style={[styles.container, { backgroundColor: theme.colors.background_1 }]}
    >
      <CarRatingsView
        monthCount={monthCount}
        onMonthCountChange={(next) => {
          setMonthCount(next);
          router.setParams({ months: String(next) });
        }}
      />
    </View>
  );
}

const stylesheet = createStyleSheet(() => ({
  container: {
    flex: 1,
  },
}));
